import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { useEffect, useEffectEvent } from "react";
import { GlobalError } from "@/components/GlobalError";

const isProduction = import.meta.env.MODE === "production";

const postHogOptions = {
	api_host: "https://us.i.posthog.com",
	defaults: "2025-11-30",
	autocapture: isProduction,
	capture_pageview: isProduction,
	capture_pageleave: isProduction,
	disable_session_recording: !isProduction,
	disable_scroll_properties: !isProduction,
	enable_heatmaps: isProduction,
	disable_surveys: !isProduction,
	logs: { captureConsoleLogs: isProduction },
} as const;

let initialized = false;

export function Provider({ children }: { children: React.ReactNode }) {
	const initPostHog = useEffectEvent(() => {
		if (initialized) return;
		initialized = true;
		posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, postHogOptions);
	});

	useEffect(() => {
		initPostHog();
	}, []);

	return (
		<PostHogProvider client={posthog}>
			<PostHogErrorBoundary fallback={<GlobalError />}>
				{children}
			</PostHogErrorBoundary>
		</PostHogProvider>
	);
}
